import { useState } from 'react'
import { EuLogin } from '@newamsterdam/ui'
import { login, ApiError } from '../api/client'
import { useUser } from '../store/user'

export function LoginView() {
  const loadUser = useUser((s) => s.load)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  async function handleLogin(email: string, password: string) {
    setError(null)
    setLoading(true)
    try {
      await login({ email, password })
      await loadUser()
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.errors?.email?.[0] ?? err.message)
      } else {
        setError('Logowanie nie powiodło się')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <EuLogin
      version="v2.0"
      error={error}
      loading={loading}
      showMicrosoftSignIn={false}
      onLogin={(email, password) => void handleLogin(email, password)}
    />
  )
}
